//Import REACT components
import React, { Component } from 'react';

//Import admin on rest components
import { GET_LIST, AppBarMobile } from 'admin-on-rest';

//import custom rest client
import restClient from '../restClient';

import withWidth from 'material-ui/utils/withWidth';
//import customerslist component
import ReviewsList from './ReviewsList';
import UserDetails from './UserDetails';

const styles = {
    flex: { display: 'flex', marginBottom: '1em' },
    leftCol: { flex: 1, marginRight: '1em' },
    rightCol: { flex: 1, marginLeft: '1em' },
    singleCol: { marginTop: '2em' },
	dashboardmessage: {flex: 1, background: '#fff', padding: '10px', color: '#284263', borderLeft: 'solid 4px #fd9512', marginBottom: '5px'},
};

class Dashboard extends Component {
   state = {};

   componentDidMount() {
        const d = new Date();
        d.setDate(d.getDate() - 30);
        
		//request data and store in state
        restClient(GET_LIST, 'member/myreviews', {
                filter: { },
                sort: { },
                pagination: { page: 1, perPage: 100 },
            })
            .then(response => response.data)
            .then(reviewsList => {
                this.setState({ reviewsList });
            })
		
		 restClient(GET_LIST, 'userauth/details', {
                filter: { },
                sort: { field: 'created_at', order: 'DESC' },
                pagination: { page: 1, perPage: 1 },
				response_single: true,
            })
            .then(response => response.data)
            .then(userDetails => {
                this.setState({ userDetails });
            })
	
    }
	
	//render component
    render() {
		const {
            reviewsList,
			userDetails = {},
        } = this.state;
        const { width } = this.props;
       	//component HTML
		return (
             <div>
               	{width === 1 && <AppBarMobile title="Cloudhints portal" />}
                
				{userDetails.dashboardmessage != '' && userDetails.dashboardmessage != null &&
				<div style={styles.flex}>
					<span style={styles.dashboardmessage}>{userDetails.dashboardmessage}</span>
                </div>
				}
				
				<div style={styles.flex}>
                    <div style={styles.leftCol}>
                        <div style={styles.flex}>
                        	 <UserDetails userdetails={userDetails} />
						</div>						
                    </div>
                    <div style={styles.rightCol}>
                        <div style={styles.flex}>
                           <ReviewsList nb='Recent ontvangen reviews' reviews={reviewsList} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withWidth()(Dashboard);



// WEBPACK FOOTER //
// ./src/dashboard/Dashboard.js